<template>
  <div class="flex rounded-full border-grey-light border p-2 my-auto">
    <img class="h-5 w-5 my-auto mr-2" :src="getImg()" alt="search" />
    <input
      class="text-sm placeholder-gray-600 outline-none text-gray-600"
      type="text"
      @input="$emit('search', $event.target.value)"
      placeholder="Search by title"
    />
  </div>
</template>

<script>
import { generateFullPath } from "../utils/fileHelpers";

export default {
  name: "Search",

  props: {
    searchInput: String,
  },

  methods: {
    getImg() {
      return generateFullPath("/themes/new_1/img/search.png");
    },
  },
};
</script>